<div class="size border border-border-bg box-border flex flex-col grow-0 shrink-0 basis-auto w-[250px] max-w-[250px] min-w-[100px] text-center">
	<div class="flex justify-between items-center content-center w-full">
		<div id="prev-date">
			<button (click)="changeMonth(-1)" class="cursor-pointer bg-transparent border-0 p-0">
				<lucide-icon name="chevron-left" [size]="16"></lucide-icon>
			</button>
		</div>
		<h1 class="text-corporate-3 opacity-80 text-[13px]">{{dateSelect | date:'MMMM, yyyy'}}</h1>
		<div id="next-date">
			<button (click)="changeMonth(1)" class="cursor-pointer bg-transparent border-0 p-0">
				<lucide-icon name="chevron-right" [size]="16"></lucide-icon>
			</button>
		</div>
	</div>
	<ol>
		<li *ngFor="let day of week" class="bg-form-bg font-bold text-xs mb-0.5 p-1 text-center border border-b border-border-bg text-corporate-3 opacity-80">{{day | slice:0:3}}</li>

        <li (click)="clickDay(day)" [style.gridColumnStart]="first ? day?.indexWeek : 'auto'"
         *ngFor="let day of monthSelect;let first = first">
			 <span  [ngClass]="{'daySelected': day.value == this.daySelected, 'dayNoSelected' : day.value !=this.daySelected}">{{day?.value}}</span>	 
		</li>
	</ol>
</div>